import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const InfoIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path
      d="M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z"
      fill="#4287FF"
    />
    <path
      d="M10 7.58078C10.5178 7.58078 10.9375 7.98925 10.9375 8.49312V14.5564C10.9375 15.0603 10.5178 15.4688 10 15.4688C9.48223 15.4688 9.0625 15.0603 9.0625 14.5564V8.49312C9.0625 7.98925 9.48223 7.58078 10 7.58078Z"
      fill="white"
    />
    <path
      d="M10.9375 5.44359C10.9375 5.94746 10.5178 6.35593 10 6.35593C9.48223 6.35593 9.0625 5.94746 9.0625 5.44359C9.0625 4.93972 9.48223 4.53125 10 4.53125C10.5178 4.53125 10.9375 4.93972 10.9375 5.44359Z"
      fill="white"
    />
  </SvgIcon>
);

export default InfoIcon;
